<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid pb-4" style="background-color: white">
            <h2 style="text-align: center" class="pt-4">นำเข้า ชม. OT *2</h2>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right">
                            เลือกพนักงาน
                        </label>
                        <div class="col-sm-4">
                            <multiselect
                                v-model="employee_id"
                                :options="optionEmployee"
                                placeholder="เลือกพนักงาน"
                                select-label=""
                                deselectLabel=""
                                :customLabel="employeeLabel"
                                track-by="id">
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table mt-4">
                <table class="table-borderless" align="center">
                    <tr v-for="(detail,index) in employeeList">
                        <td width="200">วันที่</td>
                        <td width="250">
                            <date-picker
                                :lang="lang"
                                type="date"
                                class="text-center w-100"
                                :format="changeFormat"
                                v-model="detail.date"
                                placeholder="วันที่">
                            </date-picker>
                        </td>
                        <td width="100">จำนวน ชม. OT</td>
                        <td width="250">
                            <input v-model="detail.hour"
                                   type="number" class="form-control"
                                   min="1" v-on:keypress="isNumber()"
                            />
                        </td>
                        <td width="100"><label>ชั่วโมง</label></td>
                        <td width="100">
                            <!--เพิ่ม-->
                            <button type="button" class="btn btn-primary"
                                    @click="addShoppingDetails"
                                    v-if="employeeList.length == index+1">
                                <icon name="plus"></icon>
                            </button>
                            <!--ลบ-->
                            <button type="button" class="btn btn-danger"
                                    @click="removeShoppingDetails(index)"
                                    v-if="index+1 < employeeList.length">
                                <icon name="trash"></icon>
                            </button>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="col text-center">
                <button type="button"
                        @click="saveOther"
                        class="btn btn-success">
                    <icon name="save"></icon>
                    บันทึก
                </button>
                &nbsp;
                &nbsp;
                <button type="button"
                        @click="goToOtherList"
                        class="btn btn-outline-secondary">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>

        </div>
        <!--            <pre class="alert-primary">{{form}}</pre>-->
    </div>

</template>

<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect"
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    name: "ot-form",
    components: {
        Multiselect, DatePicker
    },
    created() {
        this.$store.dispatch('ShoppingEmployee/clearFormData');
        this.$store.dispatch("Employee/getEmployeeAll").then(res => {
            this.optionEmployee = res;
        });
        this.$store.dispatch("Employee/getTypeList").then(res => {
            this.optionList = res;
        });
    },
    data() {
        return {
            optionEmployee: [],
            employeeList: [{
                employee_id: "",
                hour: "",
                recorder: "",
                date: "",
            }],
            optionList: [],
            currentDate: "",
            date: '',
            typePay: '',
            employee_id: '',
            items: [
                {
                    text: "นำเข้า ชม. OT *2",
                    to: {name: "import-ot-hour-double"}
                },
                {
                    text: "เพิ่มข้อมูล",
                    active: true
                }
            ],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            form: state => {
                return state.ShoppingEmployee.shoppingEmployeeForm;
            },
            user: state => {
                return state.Auth.user;
            },
        }),
    },
    methods: {
        isNumber() {
            let evt = window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        typeLabel(option) {
            return `${option.value}`
        },
        goToOtherList() {
            this.$router.push({
                name: "other-payment"
            })
        },
        addShoppingDetails() {
            this.employeeList = [
                ...this.employeeList,
                {
                    employee_id: "",
                    hour: "",
                    recorder: "",
                    date: "",
                }
            ];
        },
        removeShoppingDetails(index) {
            this.employeeList = this.employeeList.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        clearData() {
            this.employeeList = [{
                employee_id: "",
                hour: "",
                recorder: "",
                date: "",
            }];
            this.employee_id = '';
        },
        saveOther() {
            if (!this.employee_id) {
                alert('กรุณาเลือกพนักงาน');
            } else {
                this.employeeList.forEach(detail => {
                    if (!detail.date) alert('กรุณาเลือกวันที่ให้ครบ');
                    else detail.date = moment(detail.date).format("YYYY-MM-DD");
                    detail.recorder = this.user.name;
                    detail.employee_id = this.employee_id.id;
                });
                this.$store.dispatch("ScanEmployee/createImportHourDouble", this.employeeList).then(() => {
                    this.clearData();
                });
            }
        },
    }
}
</script>

<style scoped>

</style>
